<template>
    <div class="content-wrapper">
        <app-page-top-section title="Quotations" icon="menu" directory="quotations">
            <app-default-button
                url="quotations/create"
                title="Add Quotation"
                v-if="$can('create_lists')"
            />
        </app-page-top-section>

        <app-table
            id="quotation-list-table"
            :options="options"
            @action="getAction"
        />

        <app-confirmation-modal
            v-if="confirmationModalActive"
            modal-id="app-confirmation-modal"
            @confirmed="confirmed('quotation-list-table')"
            @cancelled="cancelled"
        />
    </div>
</template>

<script>
    import QuotationListMixin from "../../DataTable/DataTableMixins/QuotationListMixin";
    export default {
        name: "QuotationList",
        mixins: [QuotationListMixin],
        data() {
            return {
            }
        },
    }
</script>

